module.exports = __webpack_public_path__ + "883bfeabb066ef68f7f44d4ea3d4d1b7.svg";